module.exports = __webpack_public_path__ + "static/media/nodeImg.6cc66bd5.png";